import React from "react";
import IntegrationLogo from "../common/IntegrationLogo";

interface GitHubOrgWarningModalProps {
  isOpen: boolean;
  onProceed: () => void;
  onCancel: () => void;
}

const GitHubOrgWarningModal: React.FC<GitHubOrgWarningModalProps> = ({
  isOpen,
  onProceed,
  onCancel,
}) => {
  if (!isOpen) return null;

  return (
    <div className="su-integration-modal-overlay" onClick={onCancel}>
      <div
        className="su-integration-modal"
        onClick={(e) => e.stopPropagation()}
        style={{ maxWidth: "600px" }}
      >
        <div className="su-integration-modal-header">
          <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
            <IntegrationLogo name="GitHub" className="w-8 h-8" />
            <h3 style={{ margin: 0, fontSize: "20px" }}>
              Important: GitHub Organization Access
            </h3>
          </div>
        </div>

        <div
          className="su-integration-modal-body"
          style={{ padding: "24px" }}
        >
          <div
            style={{
              marginBottom: "20px",
              fontSize: "15px",
              lineHeight: "1.7",
              color: "#d1d5db",
            }}
          >
            <p style={{ marginBottom: "16px" }}>
              After clicking <strong>Continue</strong>, GitHub will ask you to
              authorize SendUpdates.ai.
            </p>

            <div
              style={{
                background: "#1e293b",
                border: "1px solid #3b82f6",
                borderRadius: "8px",
                padding: "16px",
                marginBottom: "16px",
              }}
            >
              <div style={{ fontSize: "24px", marginBottom: "12px" }}>
                {"\u{1F4A1}"}
              </div>
              <p
                style={{
                  margin: "0 0 12px 0",
                  fontWeight: 600,
                  color: "#60a5fa",
                }}
              >
                Make sure to grant organization access:
              </p>
              <ol
                style={{
                  margin: "0 0 0 0",
                  paddingLeft: "20px",
                  lineHeight: "1.8",
                  listStyleType: "decimal",
                  listStylePosition: "outside",
                }}
              >
                <li style={{ display: "list-item", marginBottom: "4px" }}>
                  Look for the{" "}
                  <strong>&quot;Organization access&quot;</strong> section
                  during authorization
                </li>
                <li style={{ display: "list-item", marginBottom: "4px" }}>
                  Click <strong>&quot;Grant&quot;</strong> or{" "}
                  <strong>&quot;Request&quot;</strong> next to each
                  organization you want to include
                </li>
                <li style={{ display: "list-item", marginBottom: "4px" }}>
                  If you skip this step, you can grant access later in
                  GitHub settings
                </li>
              </ol>
            </div>

            <div
              style={{
                background: "#422006",
                border: "1px solid #f59e0b",
                borderRadius: "8px",
                padding: "12px",
                fontSize: "14px",
                color: "#fbbf24",
              }}
            >
              <strong>Note:</strong> Without organization access, only your
              personal repositories will be available.
            </div>
          </div>
        </div>

        <div
          className="su-integration-modal-footer"
          style={{ justifyContent: "flex-end", gap: "12px" }}
        >
          <button className="su-btn-secondary" onClick={onCancel}>
            Cancel
          </button>
          <button
            className="su-btn-primary"
            onClick={onProceed}
            style={{ backgroundColor: "#6366f1", borderColor: "#6366f1", color: "#ffffff" }}
          >
            I Understand - Continue to GitHub
          </button>
        </div>
      </div>
    </div>
  );
};

export default GitHubOrgWarningModal;
